import gql from 'graphql-tag';
import RESOURCE_FRAGMENT from '../fragments/resource';
import RESOURCE_FAVORITE_FRAGMENT from '../fragments/resource-favorite';
import RESOURCE_ASSETS_FRAGMENT from '../fragments/resource-assets';

const GET_RESOURCE_FAVORITES = gql`
  query getResourceFavorites {
    resourceFavorites {
      ...BaseResource
      ...BaseResourceAssets
      ...BaseResourceFavorite
    }
  }
  ${RESOURCE_FRAGMENT}
  ${RESOURCE_FAVORITE_FRAGMENT}
  ${RESOURCE_ASSETS_FRAGMENT}
`;

export default GET_RESOURCE_FAVORITES;
